// extracted by mini-css-extract-plugin
export var container = "_41-0";
export var disabled = "_41-4";
export var fullWidth = "_41-3";
export var lined = "_41-1";
export var selected = "_41-5";
export var tab = "_41-2";